import { z } from 'zod'

import { UserLogActionType } from '@/modules/graphql/codegen/graphql'

import {
  USER_LOG_SEARCH_MAX_LENGTH,
  parseUserLogCalendarDate,
} from './userLogFilters'

const calendarDateSchema = z.string().refine(parseUserLogCalendarDate)

export const userLogsSearchSchema = z
  .object({
    from: calendarDateSchema.optional().catch(undefined),
    to: calendarDateSchema.optional().catch(undefined),
    actionTypes: z
      .array(z.nativeEnum(UserLogActionType))
      .optional()
      .catch(undefined),
    search: z
      .string()
      .max(USER_LOG_SEARCH_MAX_LENGTH)
      .optional()
      .catch(undefined),
    userLogId: z
      .string()
      .uuid()
      .transform((value) => value.toLowerCase())
      .optional()
      .catch(undefined),
  })
  .transform(({ from, to, actionTypes, search, userLogId }) => ({
    from,
    to: from && to && to >= from ? to : undefined,
    actionTypes: actionTypes?.length
      ? Array.from(new Set(actionTypes))
      : undefined,
    search: search?.trim() || undefined,
    userLogId,
  }))
